import {
  LOADING_GET_RECALLS,
  SET_RECALLS,
  GET_RECALLS_ERROR,
  ADD_RECALL,
  LOADING_ADD_RECALL,
  ADD_RECALL_ERROR,
  UPDATE_RECALL,
  UPDATE_RECALL_ERROR,
  LOADING_UPDATE_RECALL,
  DELETE_RECALL,
  LOADING_DELETE_RECALL,
  DELETE_RECALL_ERROR,
  LOADING_GET_RECALL_TYPES,
  LOADING_GET_RECALL_CATEGORIES,
  SET_RECALL_CATEGORIES,
  SET_RECALL_TYPES,
  GET_RECALL_CATEGORIES_ERROR,
  GET_RECALL_TYPES_ERROR,
  ADD_RECALL_CATEGORY,
  LOADING_ADD_RECALL_CATEGORY,
  ADD_RECALL_CATEGORY_ERROR,
  LOADING_UPDATE_RECALL_CATEGORY,
  UPDATE_RECALL_CATEGORY,
  UPDATE_RECALL_CATEGORY_ERROR,
  LOADING_DELETE_RECALL_CATEGORY,
  DELETE_RECALL_CATEGORY,
  DELETE_RECALL_CATEGORY_ERROR,
  LOADING_GET_OVERDUE_RECALLS,
  SET_OVERDUE_RECALLS,
  GET_RECALL_REMINDERS_ERROR,
  SET_RECALL_REMINDERS,
  LOADING_GET_RECALL_REMINDERS,
} from "../types";

const initialState = {
  recalls: [],
  overdue_recalls: [],
  recall_reminders: [],
  types: [],
  categories: [],
  loading_recalls: false,
  recalls_errors: null,
  loading_types: false,
  types_errors: null,
  loading_categories: false,
  categories_errors: null,
  loading_add_recall: false,
  add_recall_errors: null,
  loading_update_recall: false,
  update_recall_errors: null,
  loading_delete_recall: false,
  delete_recall_errors: null,
  loading_add_category: false,
  add_category_errors: null,
  loading_update_category: false,
  update_category_errors: null,
  loading_delete_category: false,
  delete_category_errors: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADING_GET_RECALLS:
      return {
        ...state,
        loading_recalls: true,
        recalls_errors: null,
      };
    case LOADING_GET_OVERDUE_RECALLS:
      return {
        ...state,
        loading_recalls: true,
        recalls_errors: null,
      };
    case LOADING_GET_RECALL_REMINDERS:
      return {
        ...state,
        loading_recalls: true,
        recalls_errors: null,
      };
    case LOADING_GET_RECALL_CATEGORIES:
      return {
        ...state,
        loading_categories: true,
        categories_errors: null,
      };
    case LOADING_GET_RECALL_TYPES:
      return {
        ...state,
        loading_types: true,
        types_errors: null,
      };
    case LOADING_UPDATE_RECALL:
      return {
        ...state,
        loading_update_recall: true,
        update_recall_errors: null,
        loading_add_recall: true,
        add_recall_errors: null,
      };
    case LOADING_DELETE_RECALL:
      return {
        ...state,
        loading_delete_recall: true,
        delete_recall_errors: null,
      };
    case LOADING_ADD_RECALL:
      return {
        ...state,
        loading_add_recall: true,
        add_recall_errors: null,
      };
    case SET_RECALLS:
      return {
        ...state,
        recalls: action.payload.data,
        loading_recalls: false,
        recalls_errors: null,
        total: action.payload.total,
      };
    case SET_OVERDUE_RECALLS:
      return {
        ...state,
        overdue_recalls: action.payload.data,
        loading_recalls: false,
        recalls_errors: null,
        total: action.payload.total,
      };
    case SET_RECALL_REMINDERS:
      return {
        ...state,
        recall_reminders: action.payload.data,
        loading_recalls: false,
        recalls_errors: null,
        total: action.payload.total,
      };
    case SET_RECALL_TYPES:
      return {
        ...state,
        types: action.payload,
        loading_types: false,
        types_errors: null,
      };
    case SET_RECALL_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        loading_categories: false,
        categories_errors: null,
      };
    case ADD_RECALL:
      // Ensure recalls is always an array before spreading
      const currentRecalls = Array.isArray(state.recalls) ? state.recalls : [];
      console.log("state.recalls", state.recalls);
      console.log("currentRecalls", currentRecalls);
      return {
        ...state,
        recalls: [...currentRecalls, action.payload.recall],
        loading_add_recall: false,
        add_recall_errors: null,
      };
    case UPDATE_RECALL:
      // Ensure recalls is always an array before operations
      const recallsArray = Array.isArray(state.recalls) ? state.recalls : [];
      let RECALL_index = recallsArray.findIndex(
        (x) => x.id === action.payload.id
      );
      const RECALLUpdate = [...recallsArray];
      RECALLUpdate[RECALL_index] = action.payload;
      // Also update overdue_recalls array if present
      const overdueArray = Array.isArray(state.overdue_recalls)
        ? state.overdue_recalls
        : [];
      const overdueIndex = overdueArray.findIndex(
        (x) => x.id === action.payload.id
      );
      const overdueUpdate = [...overdueArray];
      if (overdueIndex !== -1) {
        overdueUpdate[overdueIndex] = action.payload;
      }
      // Overdue list should only show pending recalls; remove if status changed
      const filteredOverdue = overdueUpdate.filter(
        (rec) => rec.status === 1 // 1 = Pending
      );
      return {
        ...state,
        recalls: [...RECALLUpdate],
        overdue_recalls: [...filteredOverdue],
        loading_update_recall: false,
        update_recall_errors: null,
        add_recall_errors: null,
        loading_add_recall: false,
      };
    case DELETE_RECALL:
      // Ensure recalls is always an array before operations
      const deleteRecallsArray = Array.isArray(state.recalls)
        ? state.recalls
        : [];
      let del_recall = deleteRecallsArray.findIndex(
        (x) => x.id === action.payload.id
      );
      return {
        ...state,
        recalls: deleteRecallsArray.filter(
          (item, index) => index !== del_recall
        ),
        loading_delete_recall: false,
        delete_recall_errors: null,
      };
    case GET_RECALLS_ERROR:
      return {
        ...state,
        loading_recalls: false,
        recalls_errors: action.payload,
      };
    case GET_RECALL_REMINDERS_ERROR:
      return {
        ...state,
        loading_recalls: false,
        recalls_errors: action.payload,
      };
    case GET_RECALL_TYPES_ERROR:
      return {
        ...state,
        loading_types: false,
        types_errors: action.payload,
      };
    case ADD_RECALL_ERROR:
      return {
        ...state,
        loading_add_recall: false,
        add_recall_errors: action.payload,
      };
    case GET_RECALL_CATEGORIES_ERROR:
      return {
        ...state,
        loading_categories: false,
        categories_errors: action.payload,
      };
    case UPDATE_RECALL_ERROR:
      return {
        ...state,
        loading_update_recall: false,
        update_recall_errors: action.payload,
        loading_add_recall: false,
        add_recall_errors: action.payload,
      };
    case DELETE_RECALL_ERROR:
      return {
        ...state,
        loading_delete_recall: false,
        delete_recall_errors: action.payload,
      };

    case LOADING_UPDATE_RECALL_CATEGORY:
      return {
        ...state,
        loading_update_category: true,
        update_category_errors: null,
      };
    case LOADING_DELETE_RECALL_CATEGORY:
      return {
        ...state,
        loading_delete_category: true,
        delete_category_errors: null,
      };
    case LOADING_ADD_RECALL_CATEGORY:
      return {
        ...state,
        loading_add_category: true,
        add_category_errors: null,
      };
    case ADD_RECALL_CATEGORY:
      // Ensure categories is always an array before spreading
      const currentCategories = Array.isArray(state.categories)
        ? state.categories
        : [];
      return {
        ...state,
        categories: [...currentCategories, action.payload],
        loading_add_category: false,
        add_category_errors: null,
      };
    case UPDATE_RECALL_CATEGORY:
      // Ensure categories is always an array before operations
      const categoriesArray = Array.isArray(state.categories)
        ? state.categories
        : [];
      let category_index = categoriesArray.findIndex(
        (x) => x.id === action.payload.id
      );
      const categoryUpdate = [...categoriesArray];
      categoryUpdate[category_index] = action.payload;
      return {
        ...state,
        categories: [...categoryUpdate],
        loading_update_category: false,
        update_category_errors: null,
        loading_add_category: false,
        add_category_errors: null,
      };
    case DELETE_RECALL_CATEGORY:
      // Ensure categories is always an array before operations
      const deleteCategoriesArray = Array.isArray(state.categories)
        ? state.categories
        : [];
      let del = deleteCategoriesArray.findIndex(
        (x) => x.id === action.payload.id
      );
      return {
        ...state,
        categories: deleteCategoriesArray.filter(
          (item, index) => index !== del
        ),
        loading_delete_category: false,
        delete_category_errors: null,
      };
    case ADD_RECALL_CATEGORY_ERROR:
      return {
        ...state,
        loading_add_category: false,
        add_category_errors: action.payload,
      };
    case UPDATE_RECALL_CATEGORY_ERROR:
      return {
        ...state,
        loading_update_category: false,
        update_category_errors: action.payload,
      };
    case DELETE_RECALL_CATEGORY_ERROR:
      return {
        ...state,
        loading_delete_category: false,
        delete_category_errors: action.payload,
      };

    default:
      return state;
  }
}
